/**
 * Venue Owner Service — Venue management, bookings, inquiries, floor plans
 */
import api from './api';

const venueOwnerService = {
  // Dashboard & Venues
  getDashboard: () => api.get('/venue-owner/dashboard').then(r => r.data),
  getVenues: () => api.get('/venue-owner/venues').then(r => r.data),
  getVenue: (id) => api.get(`/venue-owner/venues/${id}`).then(r => r.data),
  createVenue: (data) => api.post('/venue-owner/venues', data).then(r => r.data),
  updateVenue: (id, data) => api.put(`/venue-owner/venues/${id}`, data).then(r => r.data),
  getBookings: () => api.get('/venue-owner/bookings').then(r => r.data),
  // Owner-side accept / decline / mark-complete for a booking. Backend route
  // is /venue-owner/inquiries/{id} (a venue inquiry IS the booking row).
  respondInquiry: (id, payload) => api.put(`/venue-owner/inquiries/${id}`, payload).then(r => r.data),

  // Inquiries
  getInquiries: (venueId, params) => api.get(`/venue-inquiries/${venueId}`, { params }).then(r => r.data),
  getInquiryPipeline: (venueId) => api.get(`/venue-inquiries/${venueId}/pipeline`).then(r => r.data),
  createInquiry: (data) => api.post('/venue-inquiries', data).then(r => r.data),
  updateInquiry: (id, data) => api.put(`/venue-inquiries/${id}`, data).then(r => r.data),

  // Floor Plans
  getFloorPlans: (params) => api.get('/floor-plans', { params }).then(r => r.data),
  createFloorPlan: (data) => api.post('/floor-plans', data).then(r => r.data),
  updateFloorPlan: (id, data) => api.put(`/floor-plans/${id}`, data).then(r => r.data),
  deleteFloorPlan: (id) => api.delete(`/floor-plans/${id}`).then(r => r.data),

  // Reviews — public read (anyone can fetch a venue's reviews); reply
  // is auth + ownership-checked on the backend.
  getReviews: (venueId) => api.get(`/venue-reviews/${venueId}`).then(r => r.data),
  replyReview: (id, reply) => api.post(`/venue-reviews/${id}/reply`, { reply }).then(r => r.data),

  // Availability — per-venue blocked dates + seasonal pricing rules.
  // The legacy /venue-owner/availability endpoints act on the "primary
  // venue" only; these new ones are scoped by venue id so the picker
  // works for owners with multiple properties.
  getAvailability: (venueId) => api.get(`/venue-owner/venues/${venueId}/availability`).then(r => r.data),
  setAvailability: (venueId, payload) => api.post(`/venue-owner/venues/${venueId}/availability`, payload).then(r => r.data),
};

export default venueOwnerService;
